import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, SageClassnames } from '@kajabi/sage-react';
import Cart from 'apps/commerce/cart/Cart';
import '../styles/index.scss';

interface ToastWithCartLinkProps {
  message: string;
  showModal: (component: React.ElementType, props?: any) => void;
}

/**
 * A reusable component that displays a message with a "View cart" link
 * Used in toast notifications to provide a consistent way to link to the cart
 */
const ToastWithCartLink: React.FC<ToastWithCartLinkProps> = ({ message, showModal }) => {
  const { t } = useTranslation();

  return (
    <>
      {message}
      {'  '}
      <Button
        onClick={() => showModal(Cart)}
        icon={null}
        color="primary"
        iconPosition="left"
        iconSize="small"
        className={`${SageClassnames.TYPE.BODY_SEMI} ${SageClassnames.SPACERS.XS_LEFT} toast-cart-link`}
        style={{ background: 'transparent', border: 'none', padding: 0 }}
      >
        {t('messages.cart.view_cart')}
      </Button>
    </>
  );
};

export default ToastWithCartLink;
